export default "__VITE_ASSET__CX$Wmmrk__"